import { captureConsole, createConsoleRing, type ConsoleLike } from "./console-ring.ts";

/**
 * The game page's log, recorded from the moment this module loads. The page's entry imports it before anything
 * else, so the lines the boot and the join write are in a report (ADR-081's amendment of 2026-10-05, item 4).
 */

/**
 * The page's ring of console lines.
 */
export const pageLog = createConsoleRing();

captureConsole(console as unknown as ConsoleLike, pageLog, () => new Date().toISOString());
